import { render, staticRenderFns } from "./CategoryOrderSelector.vue?vue&type=template&id=2a1b5ad4&scoped=true"
import script from "./CategoryOrderSelector.vue?vue&type=script&lang=js"
export * from "./CategoryOrderSelector.vue?vue&type=script&lang=js"
import style0 from "./CategoryOrderSelector.vue?vue&type=style&index=0&id=2a1b5ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b5ad4",
  null
  
)

export default component.exports